<script>
export default {
    props: {
        disabled: {
            type: Boolean,
            required: true,
        },

        url: {
            type: String,
            required: true,
        },

        config: {
            type: Object,
            required: true
        },

        callback: {
            type: Function,
            required: true
        },
    },

    methods: {
        onClick: function () {
            let self = this

            axios(this.url, this.config).then(
                function (response) {
                    // success callback
                    self.callback()
                },
                function (response) {
                    // error callback
                    console.log('Connection Error')
                })
        }
    }
}
</script>
